import { useDispatch, useSelector } from "react-redux";
import NoDataimg from "../../../assets/No_Data.png";
import { history } from "../../../_helpers";
import { useEffect, useState } from "react";
import { eventsActions } from "../../../_store/events.slice";
import CommonModal from "../../../components/common/ui/NotificationModal/CommonModal";
import { useParams } from "react-router-dom";
import CustomLoader from "../../../components/common/ui/Loader";
import ICS from "../../../assets/ics.png";
import {
  addEventToGoogleCalendar,
  exportEventAsICS,
} from "../../../_helpers/googleCalendarUtils";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";

const CommitteeEventPage = () => {
  const dispatch = useDispatch();
  const { getCommitteeEventDetailsResponse, loading } = useSelector(
    (state) => state.events,
  );

  const { committeeID } = useParams();
  // const { committeeID } = useSelector((state) => state.committee);
  const [currentMonth, setCurrentMonth] = useState(new Date()?.getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date()?.getFullYear());
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [confirmOpenIndex, setConfirmOpenIndex] = useState(null);

  useEffect(() => {
    getCommitteeEventDetails();
  }, [currentMonth, currentYear]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  const getCommitteeEventDetails = () => {
    const committeeId = committeeID;
    // const committeeId = committeeID?._id;
    const searchParams = `committee-page?committeeId=${committeeId}&month=${currentMonth}&year=${currentYear}`;
    dispatch(eventsActions?.getCommitteeEventDetails(searchParams));
  };

  const monthYearName = new Date(currentYear, currentMonth - 1).toLocaleString(
    "en-US",
    { month: "long", year: "numeric" },
  );

  const handlePrevMonth = () => {
    setCurrentMonth((prevMonth) => {
      if (prevMonth === 1) {
        setCurrentYear((prevYear) => prevYear - 1);
        return 12; // December of previous year
      }
      return prevMonth - 1;
    });
  };

  const handleNextMonth = () => {
    setCurrentMonth((prevMonth) => {
      if (prevMonth === 12) {
        setCurrentYear((prevYear) => prevYear + 1);
        return 1; // January of next year
      }
      return prevMonth + 1;
    });
  };

  // const formatDateForGoogleCalendar = (isoDate) => {
  //   return new Date(isoDate)
  //     .toISOString()
  //     .replace(/[-:]/g, "") // remove dashes and colons
  //     .replace(".000", ""); // remove milliseconds
  // };

  // const formatDateForGoogleCalendar = (dateString) => {
  //   const localDate = new Date(dateString);

  //   const pad = (num) => String(num).padStart(2, "0");

  //   return (
  //     localDate.getFullYear() +
  //     pad(localDate.getMonth() + 1) +
  //     pad(localDate.getDate()) +
  //     "T" +
  //     pad(localDate.getHours()) +
  //     pad(localDate.getMinutes()) +
  //     pad(localDate.getSeconds())
  //   );
  // };

  // function formatICSDescription(text = "") {
  //   return text
  //     .replace(/\r\n|\r|\n/g, "\\n") // normalize all newlines
  //     .replace(/(.{1,75})/g, "$1\r\n "); // fold lines (space at start!)
  // }

  //   const handleExportICS = (e, event) => {
  //     e.preventDefault();
  //     const eventType = event?.location;
  //     const description =
  //       eventType === "hybrid"
  //         ? `${event.description}\n\nJoin link: ${event.url}`
  //         : event.description;
  //     // Build the ICS content
  //     const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Event Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // SUMMARY:${event?.title}
  // DTSTART:${formatDate(event?.start)}
  // DTEND:${formatDate(event?.end)}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event?.url || ""}
  // LOCATION:${eventType === "virtual" ? event?.url : event?.address}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //     // Create a Blob
  //     const blob = new Blob([icsContent], {
  //       type: "text/calendar;charset=utf-8",
  //     });

  //     // Create a download link
  //     const link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `${event.title || "event"}.ics`;
  //     link.click();
  //   };

  //   const handleExportICSForSingleEvent = (e, event) => {
  //     e.preventDefault();
  //     const eventType = event?.location;
  //     const description =
  //       eventType === "hybrid"
  //         ? `${event.description}\n\nJoin link: ${event.url}`
  //         : event.description;
  //     // Build the ICS content
  //     const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Event Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(event.start)}
  // DTEND:${formatDate(event.end)}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${eventType === "virtual" ? event?.url : event?.address}
  // END:VEVENT
  // END:VCALENDAR
  // `.trim();

  //     // Create a Blob
  //     const blob = new Blob([icsContent], {
  //       type: "text/calendar;charset=utf-8",
  //     });

  //     // Create a download link
  //     const link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `${event.title || "event"}.ics`;
  //     link.click();
  //   };

  //   const handleExportICS = (e, event) => {
  //     e.preventDefault();
  //     debugger;
  //     const eventType = event?.eventType;
  //     if (eventType === "single") {
  //       handleExportICSForSingleEvent(e, event);
  //     }
  //     const recurrence = event?.recurrenceId;
  //     // ---------- Helpers ----------
  //     const formatDate = (date) => {
  //       const d = new Date(date);
  //       return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  //     };
  //     const formatICSDescription = (text) => (text || "").replace(/\n/g, "\\n");
  //     const dayMap = {
  //       sunday: "SU",
  //       monday: "MO",
  //       tuesday: "TU",
  //       wednesday: "WE",
  //       thursday: "TH",
  //       friday: "FR",
  //       saturday: "SA",
  //     };
  //     const getBYDAY = (days = []) =>
  //       days.map((d) => dayMap[d.toLowerCase()]).join(",");
  //     const getDayIndex = (day) =>
  //       [
  //         "sunday",
  //         "monday",
  //         "tuesday",
  //         "wednesday",
  //         "thursday",
  //         "friday",
  //         "saturday",
  //       ].indexOf(day.toLowerCase());
  //     // ---------- Common ----------
  //     const description =
  //       event.location === "hybrid"
  //         ? `${event.description}\n\nJoin link: ${event.url}`
  //         : event.description;

  //     const duration =
  //       new Date(event.end).getTime() - new Date(event.start).getTime();

  //     // =========================================================
  //     //  CASE 1: Use explicit dates
  //     // =========================================================
  //     //     if (recurrence?.datesSelected?.length > 0) {
  //     //       let vevents = "";

  //     //       recurrence.datesSelected.forEach((date) => {
  //     //         const startDate = new Date(date);
  //     //         const endDate = new Date(startDate.getTime() + duration);

  //     //         vevents += `
  //     // BEGIN:VEVENT
  //     // UID:${startDate.getTime()}@yourapp.com
  //     // SUMMARY:${event.title}
  //     // DTSTART:${formatDate(startDate)}
  //     // DTEND:${formatDate(endDate)}
  //     // DESCRIPTION:${formatICSDescription(description)}
  //     // URL:${event.url || ""}
  //     // LOCATION:${event.location === "virtual" ? event.url : event.address}
  //     // END:VEVENT`;
  //     //       });

  //     //       const icsContent = `
  //     // BEGIN:VCALENDAR
  //     // VERSION:2.0
  //     // PRODID:-//YourApp//Universal Export//EN
  //     // CALSCALE:GREGORIAN
  //     // ${vevents}
  //     // END:VCALENDAR`.trim();

  //     //       downloadICS(icsContent, event.title);
  //     //       return;
  //     //     }
  //     // CASE 1: Use explicit dates ONLY for custom date selection

  //     if (
  //       recurrence?.datesSelected?.length > 0 &&
  //       !["day", "week", "month", "year"].includes(recurrence?.period)
  //     ) {
  //       let vevents = "";

  //       recurrence.datesSelected.forEach((date) => {
  //         const startDate = new Date(date);
  //         const endDate = new Date(startDate.getTime() + duration);

  //         vevents += `
  // BEGIN:VEVENT
  // UID:${startDate.getTime()}@yourapp.com0
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(startDate)}
  // DTEND:${formatDate(endDate)}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // END:VEVENT`;
  //       });

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // ${vevents}
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }
  //     // =========================================================
  //     //  CASE 2: WEEKLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "week") {
  //       const repeatEvery = recurrence.repeatEvery || 1;
  //       const days = recurrence.weekDaySelected || [];

  //       const getAdjustedStart = () => {
  //         let dt = new Date(recurrence.start);

  //         while (!days.some((d) => dt.getDay() === getDayIndex(d))) {
  //           dt.setDate(dt.getDate() + 1);
  //         }

  //         return dt;
  //       };

  //       const adjustedStart = getAdjustedStart();

  //       const rrule = `RRULE:FREQ=WEEKLY;INTERVAL=${repeatEvery};BYDAY=${getBYDAY(
  //         days,
  //       )};UNTIL=${formatDate(recurrence.end)}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 3: MONTHLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "month") {
  //       const repeatEvery = recurrence.repeatEvery || 1;
  //       const days = recurrence.monthDaySelected || [];

  //       const hasMultipleDays = days.length > 1;

  //       // ⚠️ Multiple weekdays → fallback needed
  //       if (hasMultipleDays) {
  //         console.warn("Monthly multi-day → use datesSelected instead");
  //         return;
  //       }

  //       const byDay = getBYDAY(days);

  //       const freqMap = {
  //         1: 1, // first week
  //         2: 2,
  //         3: 3,
  //         4: 4,
  //         5: -1, // last week
  //       };

  //       const bySetPos = freqMap[recurrence.monthFrequency];

  //       const adjustedStart = new Date(event.start);

  //       const rrule = `RRULE:FREQ=MONTHLY;INTERVAL=${repeatEvery};BYDAY=${byDay};BYSETPOS=${bySetPos};UNTIL=${formatDate(recurrence.end)}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 4: DAILY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "day") {
  //       const repeatEvery = recurrence.repeatEvery || 1;

  //       const adjustedStart = new Date(recurrence.start);

  //       const rrule = `RRULE:FREQ=DAILY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 5: YEARLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "year") {
  //       const repeatEvery = recurrence.repeatEvery || 1;

  //       const adjustedStart = new Date(recurrence.start);

  //       const rrule = `RRULE:FREQ=YEARLY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }
  //   };
  // ---------- Download helper ----------
  // function downloadICS(content, title) {
  //   const blob = new Blob([content], {
  //     type: "text/calendar;charset=utf-8",
  //   });

  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = `${title || "event"}.ics`;
  //   link.click();
  // }

  // const formatDate = (date) => {
  //   return (
  //     new Date(date).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z"
  //   );
  // };

  const regroupByLocalDate = (apiData) => {
    const map = {};

    apiData?.forEach((item) => {
      item?.events?.forEach((event) => {
        const localDate = new Date(event.start);
        const key = `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, "0")}-${String(localDate.getDate()).padStart(2, "0")}`;

        if (!map[key]) {
          map[key] = { date: key, events: [] };
        }
        map[key].events.push(event);
      });
    });

    return Object.values(map).sort(
      (a, b) => new Date(a.date) - new Date(b.date),
    );
  };

  // const getGoogleCalendarDatesAndRecur = (event) => {
  //   const recurrence = event?.recurrenceId;
  //   const duration =
  //     new Date(event.end).getTime() - new Date(event.start).getTime();

  //   const dayMap = {
  //     sunday: "SU",
  //     monday: "MO",
  //     tuesday: "TU",
  //     wednesday: "WE",
  //     thursday: "TH",
  //     friday: "FR",
  //     saturday: "SA",
  //   };
  //   const getBYDAY = (days = []) =>
  //     days.map((d) => dayMap[d.toLowerCase()]).join(",");
  //   const getDayIndex = (day) =>
  //     [
  //       "sunday",
  //       "monday",
  //       "tuesday",
  //       "wednesday",
  //       "thursday",
  //       "friday",
  //       "saturday",
  //     ].indexOf(day.toLowerCase());

  //   // Not a recurring event → use start/end as-is
  //   if (event?.eventType !== "recurrence" || !recurrence) {
  //     return { start: event?.start, end: event?.end, recur: null };
  //   }

  //   // Custom explicit dates (not day/week/month/year) →
  //   // Google's template URL can't hold multiple arbitrary dates,
  //   // so we show only the first occurrence.
  //   if (
  //     recurrence?.datesSelected?.length > 0 &&
  //     !["day", "week", "month", "year"].includes(recurrence?.period)
  //   ) {
  //     const firstDate = new Date(recurrence.datesSelected[0]);
  //     return {
  //       start: firstDate,
  //       end: new Date(firstDate.getTime() + duration),
  //       recur: null,
  //       isPartialOnly: true,
  //     };
  //   }

  //   // Weekly
  //   if (recurrence?.period === "week") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const days = recurrence.weekDaySelected || [];
  //     let dt = new Date(recurrence.start);
  //     while (!days.some((d) => dt.getDay() === getDayIndex(d))) {
  //       dt.setDate(dt.getDate() + 1);
  //     }
  //     return {
  //       start: dt,
  //       end: new Date(dt.getTime() + duration),
  //       recur: `RRULE:FREQ=WEEKLY;INTERVAL=${repeatEvery};BYDAY=${getBYDAY(
  //         days,
  //       )};UNTIL=${formatDate(recurrence.end)}`,
  //     };
  //   }

  //   // Monthly
  //   if (recurrence?.period === "month") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const days = recurrence.monthDaySelected || [];
  //     if (days.length > 1) {
  //       // multi-weekday monthly recurrence isn't expressible in one RRULE here
  //       return {
  //         start: event?.start,
  //         end: event?.end,
  //         recur: null,
  //         isPartialOnly: true,
  //       };
  //     }
  //     const freqMap = { 1: 1, 2: 2, 3: 3, 4: 4, 5: -1 };
  //     const start = new Date(event.start);
  //     return {
  //       start,
  //       end: new Date(start.getTime() + duration),
  //       recur: `RRULE:FREQ=MONTHLY;INTERVAL=${repeatEvery};BYDAY=${getBYDAY(
  //         days,
  //       )};BYSETPOS=${freqMap[recurrence.monthFrequency]};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`,
  //     };
  //   }

  //   // Daily
  //   if (recurrence?.period === "day") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const start = new Date(recurrence.start);
  //     return {
  //       start,
  //       end: new Date(start.getTime() + duration),
  //       recur: `RRULE:FREQ=DAILY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`,
  //     };
  //   }

  //   // Yearly
  //   if (recurrence?.period === "year") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const start = new Date(recurrence.start);
  //     return {
  //       start,
  //       end: new Date(start.getTime() + duration),
  //       recur: `RRULE:FREQ=YEARLY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`,
  //     };
  //   }

  //   return { start: event?.start, end: event?.end, recur: null };
  // };

  // const buildGoogleCalendarUrl = (event) => {
  //   const { start, end, recur } = getGoogleCalendarDatesAndRecur(event);

  //   const params = new URLSearchParams();
  //   params.set("action", "TEMPLATE");
  //   params.set("text", event?.title || "");
  //   params.set(
  //     "dates",
  //     `${formatDateForGoogleCalendar(start)}/${formatDateForGoogleCalendar(end)}`,
  //   );
  //   params.set(
  //     "location",
  //     event?.location === "virtual" ? event?.url || "" : event?.address || "",
  //   );
  //   params.set(
  //     "details",
  //     event?.location === "hybrid"
  //       ? `${event?.description || ""}\n\nJoin link: ${event?.url || ""}`
  //       : event?.description || "",
  //   );
  //   params.set("sf", "true");
  //   params.set("output", "xml");
  //   if (recur) params.set("recur", recur);

  //   return `https://calendar.google.com/calendar/render?${params.toString()}`;
  // };

  useEffect(() => {
    if (confirmOpenIndex === null) return;

    const handleClickOutside = (e) => {
      if (
        !e.target.closest(".gcal-popover") &&
        !e.target.closest(".join-btn")
      ) {
        setConfirmOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [confirmOpenIndex]);

  const handleGoogleCalendarClick = (index) => {
    setConfirmOpenIndex(index === confirmOpenIndex ? null : index);
  };

  const handleConfirmYes = (event) => {
    addEventToGoogleCalendar(event, {
      // onSuccess: () => alert("Event added to your Google Calendar!"),
      onSuccess: () => {
        showToastNotification(
          "Event added to your Google Calendar!",
          "success",
        );
      },
      onError: (err) => {
        console.error("Google Calendar insert error:", err);
        //alert(err.message || "Failed to add event to Google Calendar.");
        showToastNotification(
          "Failed to add event to Google Calendar.",
          "error",
        );
      },
    });
    setConfirmOpenIndex(null);
  };

  const handleConfirmCancel = () => {
    setConfirmOpenIndex(null);
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="committee-calender-next-prev p-4 paddingtop-100">
        <div class="container position-relative">
          <div class="row">
            {/* <div className="month-year-name">{monthYearName}</div> */}
            <h1 class="main-title month-year-name">{monthYearName}</h1>
            <div className="d-flex gap-2">
              <div class="swiper-nav">
                <div class="swiper-button-prev" onClick={handlePrevMonth}></div>
                <div class="swiper-button-next" onClick={handleNextMonth}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {getCommitteeEventDetailsResponse?.data?.length > 0 ? (
        <section className="events-section paddingtop-100">
          <div className="container">
            <div className="row d-flex gap-4 ">
              {regroupByLocalDate(getCommitteeEventDetailsResponse?.data)?.map(
                (item, index) => {
                  const localDate = new Date(item.date + "T00:00:00");
                  const eventDate = localDate
                    .getDate()
                    .toString()
                    .padStart(2, "0");
                  const eventDay = localDate
                    .toLocaleString("en-us", { weekday: "short" })
                    .toUpperCase();

                  return (
                    <div
                      className="col-md-5 d-flex align-items-center gap-3 cursor-pointer committee-calender-container"
                      key={index}
                      onClick={() => {
                        setSelectedEvents(item);
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#bcsp-committee-event-calneder-modal"
                    >
                      {/* Date */}
                      <div
                        className="text-center flex-shrink-0"
                        style={{
                          width: "100px",
                        }}
                      >
                        <div className="committe-calender-day-section">
                          <div className="committe-calender-day">{eventDate}</div>
                          <span className="committe-calender-day-name">
                            {eventDay}
                          </span>
                        </div>
                      </div>

                      {/* Events */}
                      <div
                        className="flex-grow-1"
                        style={{
                          minWidth: 0,
                        }}
                      >
                        {item?.events?.length > 0 &&
                          item.events.map((e, i) => {
                            const formattedTime = new Date(e.start)
                              .toLocaleString("en-IN", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                              .replace(/am|pm/, (match) => match.toUpperCase());

                            return (
                              <div
                                key={i}
                                className="d-grid align-items-start"
                                style={{
                                  gridTemplateColumns: "6.5em minmax(0, 1fr)",
                                  columnGap: "1em",
                                }}
                              >
                                {/* Time */}
                                <div className="text-nowrap committe-calender-time">
                                  {formattedTime}
                                </div>

                                {/* Event title */}
                                <div
                                  style={{
                                    minWidth: 0,
                                    overflowWrap: "anywhere",
                                    wordBreak: "break-word",
                                  }}
                                  className="committe-calender-event-name"
                                >
                                  {e?.title}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  );
                },
              )}
            </div>
          </div>
        </section>
      ) : (
        <div className="sign-in-section">
          <div className="container">
            <div className="login-container">
              <div className="error-page-box p-5 d-flex flex-column justify-content-center align-items-center">
                <img src={NoDataimg} alt="404" />
                <h2 className="error-page-label">No Events Found</h2>
                <button
                  onClick={() => history?.navigate("/Home")}
                  type="submit"
                  className="sign-in-button"
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <CommonModal
        modalId="bcsp-committee-event-calneder-modal"
        // title={"Events of " + clickedDate}
        modalSize="modal-lg"
        bodyContent={
          <>
            {selectedEvents?.events?.length > 0 ? (
              <ul>
                {selectedEvents?.events?.map((event, index) => (
                  <>
                    {console.log("event", event)}
                    {index !== 0 && <hr />}
                    <li key={index} className="bpk-public-event-list">
                      <h3>{event?.committee?.committeeName}</h3>
                      {/* <h4>{event?.committee?.committeeName}</h4> */}
                      {/* <strong>{event.title}</strong> */}
                      <h4>{event.title}</h4>
                      {/* <br /> */}
                      <div className="mt-2">
                        <i className="fa fa-calendar" aria-hidden="true"></i>{" "}
                        {new Date(event.start).toLocaleString([], {
                          year: "numeric",
                          month: "2-digit",
                          day: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                        })}{" "}

                        –{" "}

                        {new Date(event.end).toLocaleString([], {
                          year: "numeric",
                          month: "2-digit",
                          day: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                        })}
                      </div>

                      {/* <br /> */}

                      {event?.address && (
                        <div className="mt-2">
                          <i
                            className="fa fa-location-arrow"
                            aria-hidden="true"
                          ></i>
                          {/* <i class="fa fa-map-marker" aria-hidden="true"></i> */}
                          <span className="event-address-name">
                            {" " + event?.address}
                          </span>
                        </div>
                      )}

                      {(event?.image || event?.document) && (
                        <div className="mt-3 d-flex flex-wrap gap-3 align-items-center">
                          {event?.image && (
                            <div className="d-flex flex-column align-items-start">
                              <a
                                href={`${process.env.REACT_APP_API_IMAGE_URL || ""}${event.image}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="event-thumb-wrapper"
                                title="Click to view image"
                              >
                                <img
                                  src={`${process.env.REACT_APP_API_IMAGE_URL || ""}${event.image}`}
                                  alt={event?.title || "Event Image"}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                                <div className="thumb-overlay">
                                  <i
                                    className="fa fa-download"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </a>
                            </div>
                          )}

                          {event?.document && (
                            <div className="d-flex flex-column align-items-start">

                              <a
                                href={`${process.env.REACT_APP_API_IMAGE_URL || ""}${event.document}`}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="event-thumb-wrapper"
                                title="Click to download document"
                              >
                                <div className="doc-placeholder-icon">
                                  <i
                                    className="fa fa-file-text"
                                    aria-hidden="true"
                                    style={{ fontSize: "28px", color: "#660099" }}
                                  ></i>
                                </div>
                                <div className="thumb-overlay">
                                  <i
                                    className="fa fa-download"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      )}

                      <div className="d-flex mt-3 flex-wrap gap-2">
                        {event?.url && (
                          <a
                            href={event?.url}
                            target="self"
                            rel="noopener noreferrer"
                            className="join-btn"
                          >
                            <i
                              class="fa fa-video-camera"
                              aria-hidden="true"
                            ></i>
                            <div className="mx-2">Join</div>
                          </a>
                        )}


                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <button
                            type="button"
                            className="join-btn"
                            style={{ border: "none" }}
                            onClick={() => handleGoogleCalendarClick(index)}
                          >
                            <i
                              class="fa fa-calendar-plus"
                              aria-hidden="true"
                            ></i>
                            <span className="mx-2">Add to Google Calendar</span>
                          </button>

                          <div
                            className={`gcal-popover ${confirmOpenIndex === index
                              ? "gcal-popover-open"
                              : ""
                              }`}
                          >
                            <div className="gcal-popover-arrow" />
                            <div className="gcal-popover-icon">
                              <i
                                className="fa fa-calendar-plus"
                                aria-hidden="true"
                              ></i>
                              <p className="gcal-popover-text">
                                Are you sure you want to add this event to your
                                Google Calendar?
                              </p>
                            </div>
                            <div className="gcal-popover-actions">
                              <button
                                type="button"
                                className="gcal-btn-cancel"
                                onClick={handleConfirmCancel}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="gcal-btn-confirm"
                                onClick={() => handleConfirmYes(event)}
                              >
                                Yes, Add
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>

                          <a
                            href={event?.url}
                            target="self"
                            className="join-btn cursor-pointer"
                            // onClick={(e) => {
                            //   handleExportICS(e, event);
                            // }}
                            onClick={(e) => {
                              e.preventDefault();
                              exportEventAsICS(event);
                            }}
                          >
                            <img height="20px" width="20px" src={ICS} alt="" />
                            <span className="mx-2">Export as .ics file</span>
                          </a>
                        </div>
                      </div>
                      {event?.description && (
                        <div className="mt-3">
                          <strong className="text-decoration-underline">
                            Description{" "}
                          </strong>
                          <div className="w-100">
                            <p className="indent text-break" style={{ overflowWrap: "anywhere" }}>{event?.description}</p>
                          </div>
                        </div>
                      )}
                      {/* {event?.eventType === "recurrence" && (
                        <div style={{ color: "red", marginTop: "5px" }}>
                          Since this is a recurring event, please add the series
                          manually to your calendar.
                        </div>
                      )} */}
                    </li>
                  </>
                ))}
              </ul>
            ) : (
              <p>No events found.</p>
            )}
          </>
        }
        footerContent={
          <button className="btn button-primary" data-bs-dismiss="modal">
            Close
          </button>
        }
      />
    </>
  );
};

export default CommitteeEventPage;
